import { format, parse } from 'date-fns'
import { PaymentsTemplateType } from '~/shared/api'
import { datetime } from '~/shared/config'
import { GridRow } from './types'

export const mapPaymentSchedulesToRows = (
  paymentsTemplate: PaymentsTemplateType[],
  workSchedule?: string,
): GridRow[] =>
  paymentsTemplate.map((template) => ({
    ...template,
    workSchedule,
    time: format(
      parse(template.time, 'HH:mm:ss', new Date()),
      datetime.apiDateTimeFormat,
    ),
  }))
